import { css } from "goober";

export const Container = () => css`
  .below {
    padding-block-start: var(--sp-4);
    background: var(--card-surface2);
    box-shadow: inset 0 1px var(--card-inset-border);

    &:not(:has(:nth-child(2))) {
      display: none;
    }
  }
  .below-title {
    display: block;
    padding-inline: var(--sp-6);
  }
`;

export const RankInfo = () => css`
  & {
    display: flex;
    align-items: center;
    gap: var(--sp-3);
    padding: var(--sp-4) var(--sp-6);
    padding-block-start: 0;
  }

  &.has-image {
    padding-inline-start: var(--sp-5);
  }

  .rank-image--component,
  .rank-image--component svg {
    width: var(--sp-18);
    height: auto;
  }

  .meta {
    flex: 1;
    display: grid;
    gap: var(--sp-2);
  }

  .top-line,
  .bottom-line {
    display: flex;
    justify-content: space-between;
    gap: var(--sp-2);
  }

  .top-line {
    align-items: center;
  }
  .points {
  }
  .bar {
    position: relative;
    height: var(--sp-1_5);
    background: var(--shade7);
    border-radius: var(--br);
    box-shadow: inset 0 0 0 1px var(--shade3-15);
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: var(--bar-fill);
      background: var(--bar-color);
    }
  }

  .bottom-line {
  }
`;

export const StatsBlock = () => css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--sp-1) var(--sp-8);
  padding-inline: var(--sp-6);
  padding-block-end: var(--sp-4);

  .stat-line {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }
`;

export const AccordionContainer = () => css`
  details {
    &:not(:last-child) {
      border-bottom: 1px solid var(--card-inset-border);
    }

    &[open],
    &:hover {
      background: var(--shade7);
    }

    &[open] {
      summary {
        color: var(--shade0);

        &:hover {
          background: var(--shade7);
        }
      }
    }
  }

  summary,
  .summary-label,
  .summary-rank {
    display: flex;
    align-items: center;
    gap: var(--sp-3);
  }
  summary {
    justify-content: space-between;
    padding: var(--sp-3) var(--sp-6);
    color: var(--shade1);
    cursor: pointer;
    user-select: none;

    svg {
      width: var(--sp-4_5);
      height: auto;
    }
  }
  .summary-rank {
    color: var(--summary-color);
  }
`;
